"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
/**
 *  @swagger
 *  components:
 *    schemas:
 *      Role:
 *        type: object
 *        enum:
 *          - SPYMASTER
 *          - SPY
 */
var Role;
(function (Role) {
    Role["SPY"] = "spy";
    Role["SPYMASTER"] = "spymaster";
})(Role = exports.Role || (exports.Role = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGVyc29uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3BlcnNvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUF1Q0E7Ozs7Ozs7OztHQVNHO0FBQ0gsSUFBWSxJQUdYO0FBSEQsV0FBWSxJQUFJO0lBQ2QsbUJBQVcsQ0FBQTtJQUNYLCtCQUF1QixDQUFBO0FBQ3pCLENBQUMsRUFIVyxJQUFJLEdBQUosWUFBSSxLQUFKLFlBQUksUUFHZiJ9